(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solis-collection-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var d = document.querySelector('[data-sr-disclose]');
    if (!d) return;
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() { d.open = mq.matches; }
    sync();
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solis-contact-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const chatLinks = document.querySelectorAll('[data-sr-open-chat]');

    chatLinks.forEach((chatLink) => {
      if (chatLink.dataset.srChatReady === 'true') return;
      chatLink.dataset.srChatReady = 'true';

      chatLink.addEventListener('click', (event) => {
        event.preventDefault();
        let opened = false;

        const openChat = () => {
          if (!window.solisOpenChat || !window.solisOpenChat()) return false;
          opened = true;
          return true;
        };

        if (openChat()) return;

        window.setTimeout(openChat, 1500);
        window.setTimeout(() => {
          if (!opened) {
            document.querySelector('#SolisContactForm')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        }, 1800);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
